import React from 'react';
import { FadeIn } from '../FadeIn';
export function AboutMeAHA() {
  return <section className="relative py-24 md:py-32 bg-forest overflow-hidden" data-id="element-54">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-55">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gold/5 rounded-full blur-3xl" data-id="element-56"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-white/5 rounded-full blur-3xl" data-id="element-57"></div>

        {/* Large background text */}
        <div className="absolute top-1/2 right-0 -translate-y-1/2 text-[40vw] font-serif font-bold text-ivory/[0.03] leading-none select-none" data-id="element-58">
          M
        </div>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-8 relative z-10" data-id="element-59">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-60">
          <div className="lg:col-span-5" data-id="element-61">
            <FadeIn direction="left" data-id="element-62">
              <div className="relative" data-id="element-63">
                <div className="absolute -top-6 -left-6 w-32 h-32 bg-gold/10 rounded-full blur-2xl -z-10" data-id="element-64"></div>
                <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-ivory/10 rounded-full blur-2xl -z-10" data-id="element-65"></div>

                <div className="rounded-[32px] overflow-hidden border border-white/10 shadow-2xl relative" data-id="element-66">
                  <img src="https://cdn.magicpatterns.com/uploads/bbhRnscRmaZkzuZMMer6an/Foto_1.jpg" alt="Mihaela Iovu" className="w-full h-auto object-cover aspect-[3/4]" data-id="element-67" />
                  <div className="absolute inset-0 bg-forest/10 mix-blend-multiply pointer-events-none" data-id="element-68"></div>
                </div>

                <div className="absolute -bottom-8 -right-8 w-24 h-24 border-2 border-gold/20 rounded-full -z-10" data-id="element-69"></div>
              </div>
            </FadeIn>
          </div>

          <div className="lg:col-span-7" data-id="element-70">
            <FadeIn data-id="element-71">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-ivory mb-8 text-left" data-id="element-72">
                Cine sunt eu și de ce am creat acest curs
              </h2>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-73">
              <div className="space-y-5 text-ivory/80 font-sans text-[19px] leading-relaxed text-left" data-id="element-74">
                <p className="font-medium text-gold text-xl" data-id="element-75">
                  Sunt Mihaela Iovu. Master Trainer NLP, facilitator Constelații
                  Familiale, Master Coach acreditat de Ministerul Muncii.
                </p>

                <p data-id="element-76">
                  Am trecut eu însămi prin momente în care nu știam ce să fac cu
                  ce simțeam. Am lucrat 16 ani în mediul corporate, am trecut
                  prin divorț, am reconstruit totul de la zero. Și am învățat pe
                  propria piele că{' '}
                  <span className="font-serif italic text-gold text-xl" data-id="element-77">
                    a nu simți
                  </span>{' '}
                  nu este o soluție, iar{' '}
                  <span className="font-serif italic text-gold text-xl" data-id="element-78">
                    a simți totul deodată
                  </span>{' '}
                  nu este nici ea.
                </p>

                <p data-id="element-79">
                  Am creat acest mini-curs pentru femeile care nu au acum timp
                  sau resurse pentru un program lung, dar au nevoie urgentă de
                  instrumente concrete. Nu de teorie, nu de cărți groase. De
                  ceva ce pot folosi astăzi, în mașină, la birou, acasă.
                </p>

                <div className="mt-8 pt-6 border-t border-white/10" data-id="element-80">
                  <p className="font-medium text-ivory" data-id="element-81">
                    Tehnicile pe care le predau aici fac parte din metoda
                    A.R.I.S.E., procesul prin care lucrez de ani de zile cu
                    clientele mele. Le-am simplificat și le-am pus într-un
                    format pe care îl poți parcurge într-o săptămână. Este
                    primul pas, nu ultimul. Dar este un pas real.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}